import Pidgin from '@lessonnine/pidgin.js';
import { LOCALE, isPrivateEnv } from 'src/dataLayer/env';

const importAll = (req) =>
  req.keys().reduce((acc, file) => {
    let locale = file.replace('./', '').replace('.json', '');
    if (locale === 'en-GB') locale = 'en_GB';

    return {
      ...acc,
      [locale]: req(file)
    };
  }, {});

const locales = importAll(
  require.context('src/viewLayer/assets/locales', false, /\.json$/)
);

const pidgin = new Pidgin({
  locales,
  onMissingKey: () => { if (isPrivateEnv()) return; },
  isICU: true
});

const translations = () => {
  if (pidgin.locale !== LOCALE) {
    pidgin.configure({ locale: LOCALE });
  }
  return pidgin;
};

export const t = (...parameters) =>
  translations().t(...parameters);

export const namespaceT = (...parameters) =>
  translations().namespace(...parameters);
